/*
  Restock · barra de pedido (sep-2026).
  Barra fija abajo que refleja el CARRITO DE VERDAD y deja llevarse varios productos sin salir de la página:
  pulsas «Añadir» en un aceite → se añade al carrito, la barra pasa a «Mandarina Roja añadida · N artículos»
  y desde ahí se sigue añadiendo el resto (panel con + / −) o se va al checkout. Arriba, en la navegación,
  cada producto añadido lleva su marca. Sin descuentos: precios y stock salen de Shopify.

  ESTADO: siempre se lee /cart.js (al cargar, tras cada cambio y cuando el tema refresca el carrito), así que
  funciona aunque ya hubiera cosas en el carrito (Etnalia, regalo de Palo Santo) o se compre desde otra pestaña.

  CUÁNDO SE VE: por defecto, solo cuando algún aceite se puede comprar de verdad:
    - fase manual BUY, o ya es la fecha de «venta para todos», o
    - es la fecha de «abre para la lista» y esta persona tiene el acceso (localStorage fh_restock_lista,
      que pone ?acceso=lista de los emails).
  Fases y fechas: Configuración del tema → «Restock · fases» (window.FHRestockPagina.cfg.fases).
  QA: ?fase=buy (y ?rs_preview=publico) fuerzan la venta en el navegador; ?ped=open abre el panel; en el
  Personalizador manda «ver la fase…». Con la barra puesta se esconden las barras fijas de cada producto
  (html.rs-pedido-on).
*/
(function(){
  if(window.FHRestockPedidoJS)return;window.FHRestockPedidoJS=true;
  var PG=window.FHRestockPagina,doc=document,html=doc.documentElement,KEY=(PG&&PG.cfg&&PG.cfg.lsKey)||'fh_restock_lista';
  var open=false,busy=false,loaded={},timer=null,ultimo='',chain=Promise.resolve(),pend={};
  var cart={count:0,total:0,qty:{},key:{}};
  var qs;try{qs=new URLSearchParams(location.search)}catch(e){qs={get:function(){return null}}}
  if(qs.get('acceso')==='lista'){try{localStorage.setItem(KEY,'1')}catch(e){}}

  function root(){return doc.querySelector('[data-rs-ped]')}
  function cfgOf(r){try{return JSON.parse(r.querySelector('[data-rs-ped-config]').textContent)}catch(e){return null}}
  function access(){try{return localStorage.getItem(KEY)==='1'}catch(e){return false}}
  function fases(){var P=window.FHRestockPagina;return (P&&P.cfg&&P.cfg.fases)||{}}
  function editor(){var P=window.FHRestockPagina;return (P&&P.cfg&&P.cfg.editor)||null}
  function prodDe(c,clave){var l=(c&&c.productos)||[],i;for(i=0;i<l.length;i++){if(l[i].clave===clave)return l[i]}return null}

  // «AAAA-MM-DD» + «HH:MM» en hora de Madrid → timestamp
  function madrid(d,h){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec((d||'').trim()),t=/^(\d{1,2}):(\d{2})$/.exec((h||'00:00').trim());
    if(!m||!t)return NaN;
    var guess=Date.UTC(+m[1],+m[2]-1,+m[3],+t[1],+t[2]);
    try{
      var parts={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'}).formatToParts(new Date(guess)).forEach(function(x){parts[x.type]=x.value});
      return guess-(Date.UTC(+parts.year,+parts.month-1,+parts.day,+parts.hour,+parts.minute)-guess);
    }catch(e){return guess-2*3600e3}
  }

  // ¿este producto se puede comprar ahora mismo?
  function venta(clave){
    var ed=editor();
    if(ed&&(ed.producto==='todos'||ed.producto===clave))return ed.fase==='buy';
    var pf=qs.get('fase');
    if(pf==='buy')return true;
    if(pf==='hype'||pf==='tease')return false;
    var pv=qs.get('rs_preview');
    if(pv==='publico')return true;
    if(pv==='antes')return false;
    if(pv==='abierto')return access();
    var f=fases()[clave];
    if(!f)return true;                       // sin fases (el difusor): a la venta siempre
    if(f.fm==='buy')return true;
    if(f.fm==='tease')return false;
    var n=Date.now(),tb=madrid(f.buy[0],f.buy[1]),tl=madrid(f.lista[0],f.lista[1]);
    if(!isNaN(tb)&&n>=tb)return true;        // venta para todos
    if(!isNaN(tl)&&n>=tl&&access())return true; // 48 h solo para la lista
    return false;
  }

  // ¿quedan pocas? Se lee el stock real, pero el número NUNCA se enseña: solo decide el aviso.
  function pocas(p,c){
    if(!p||p.available===false)return false;
    var u=(c&&c.stock_umbral)||0;
    return u>0&&typeof p.inv==='number'&&p.inv>0&&p.inv<=u;
  }
  function avisaStock(c){
    var d={};
    (c&&c.productos||[]).forEach(function(p){d[p.clave]={pocas:pocas(p,c),agotado:p.available===false}});
    // aviso de pocas unidades del hero (el número no se enseña, solo enciende el aviso)
    doc.querySelectorAll('[data-rs-few]').forEach(function(el){
      var st=d[el.getAttribute('data-rs-few')];
      if(st)el.hidden=!st.pocas;
    });
    try{doc.dispatchEvent(new CustomEvent('rs:stock',{detail:d}))}catch(e){}
  }

  function money(c,cur){
    try{return new Intl.NumberFormat('es-ES',{style:'currency',currency:cur||'EUR'}).format(c/100)}
    catch(e){return (c/100).toFixed(2).replace('.',',')+' €'}
  }
  function tpl(s,n,p){return (s||'').replace('[n]',n).replace('[x]',n).replace('[producto]',p||'')}

  /* ── datos de Shopify: precio y stock de verdad ─────────────────────────────────── */
  function carga(r,c){
    (c.productos||[]).forEach(function(p){
      if(!p.handle||loaded[p.handle])return;
      loaded[p.handle]=true;
      fetch('/products/'+p.handle+'.js').then(function(x){return x.ok?x.json():null}).then(function(j){
        if(!j)return;
        var v=j.variants.filter(function(x){return x.available})[0]||j.variants[0]||null;
        p.id=v?v.id:null;p.price=v?v.price:j.price;p.available=!!(v&&v.available);
        pinta(r,c);
      }).catch(function(){});
    });
  }

  /* ── carrito de verdad ──────────────────────────────────────────────────────────── */
  function leeCarrito(){
    var r=root();if(!r)return Promise.resolve();
    var c=cfgOf(r);if(!c)return Promise.resolve();
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(x){return x.ok?x.json():null}).then(function(j){
      if(!j)return;
      cart.count=j.item_count||0;cart.total=j.total_price||0;cart.qty={};cart.key={};
      (j.items||[]).forEach(function(it){
        (c.productos||[]).forEach(function(p){
          if((p.id&&p.id===it.id)||(p.handle&&p.handle===it.handle)){
            cart.qty[p.clave]=(cart.qty[p.clave]||0)+it.quantity;
            cart.key[p.clave]=it.key;
          }
        });
      });
      pinta(r,c);avisa();
    }).catch(function(){});
  }
  // qty visible: lo pendiente (optimista) manda sobre lo confirmado
  function q(clave){return pend[clave]!=null?pend[clave]:(cart.qty[clave]||0)}

  function guarda(clave,nueva){
    var r=root(),c=r&&cfgOf(r);if(!c)return;
    var p=prodDe(c,clave);if(!p||!p.id)return;
    pend[clave]=nueva;pinta(r,c);avisa();
    chain=chain.then(function(){
      var key=cart.key[clave],body,url;
      if(key){url='/cart/change.js';body={id:key,quantity:nueva}}
      else{if(nueva<=0)return null;url='/cart/add.js';body={items:[{id:p.id,quantity:nueva}]}}
      return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(x){if(!x.ok)throw 0;return x.json()});
    }).then(function(){
      delete pend[clave];
      return window.fhRefreshCart?window.fhRefreshCart():null;
    }).then(function(){return leeCarrito()})
      .catch(function(){delete pend[clave];return leeCarrito()});
  }

  /* ── pintado ────────────────────────────────────────────────────────────────────── */
  function pinta(r,c){
    if(!r||!c)return;
    var L=c.labels||{},vis=0,n=0,total=0,cur=c.currency||'EUR';
    (c.productos||[]).forEach(function(p){
      var fila=r.querySelector('[data-rs-ped-row="'+p.clave+'"]');
      if(!fila)return;
      var on=venta(p.clave);
      fila.hidden=!on;
      if(!on)return;
      vis++;
      var hay=p.available!==false,qq=hay?q(p.clave):0;
      var out=fila.querySelector('[data-rs-ped-q]'),menos=fila.querySelector('[data-rs-ped-menos]'),mas=fila.querySelector('[data-rs-ped-mas]'),
          pre=fila.querySelector('[data-rs-ped-price]'),ago=fila.querySelector('[data-rs-ped-out]'),chk=fila.querySelector('[data-rs-ped-check]');
      if(out)out.textContent=qq;
      if(menos)menos.disabled=!hay||qq<=0;
      if(mas)mas.disabled=!hay||qq>=(c.max||10);
      if(pre&&p.price!=null)pre.textContent=money(p.price,cur);
      if(ago)ago.hidden=hay;
      if(pre)pre.hidden=!hay;
      if(chk)chk.hidden=qq<=0;
      var few=fila.querySelector('[data-rs-ped-few]');
      if(few)few.hidden=!pocas(p,c);
      fila.classList.toggle('is-on',qq>0);
      fila.classList.toggle('is-off',!hay);
      n+=qq;total+=qq*(p.price||0);
    });

    if(ultimo){
      var sigue=(c.productos||[]).some(function(p){return p.nombre===ultimo&&q(p.clave)>0});
      if(!sigue)ultimo='';
    }
    // el total y el contador son los del carrito de verdad (puede llevar más cosas)
    var nCarrito=cart.count||n,totalCarrito=cart.total||total;
    var txt=r.querySelector('[data-rs-ped-resumen]'),tot=r.querySelector('[data-rs-ped-total]'),
        cnt=r.querySelector('[data-rs-ped-count]'),add=r.querySelector('[data-rs-ped-add]'),
        go=r.querySelector('[data-rs-ped-go]'),tit=r.querySelector('[data-rs-ped-titulo]'),
        env=r.querySelector('[data-rs-ped-envio]'),prog=r.querySelector('[data-rs-ped-prog]');
    var packOn=!!c.pack&&nCarrito===0&&packItems(c).length>1;
    if(txt)txt.textContent=nCarrito===0?((packOn&&L.resumen_pack)||L.resumen_vacio||''):(nCarrito===1?(L.resumen_uno||''):tpl(L.resumen_varios,nCarrito));
    if(tit)tit.textContent=(nCarrito>0&&ultimo&&L.resumen_anadido)?tpl(L.resumen_anadido,nCarrito,ultimo):(L.titulo||'');
    if(tot)tot.textContent=money(totalCarrito,cur);
    if(cnt){cnt.textContent=nCarrito;cnt.classList.toggle('is-on',nCarrito>0)}
    r.classList.toggle('has-items',nCarrito>0);
    if(add&&!busy){
      add.disabled=false;add.classList.toggle('is-vacio',nCarrito===0);
      // pack completo: con el carrito vacío el botón es el principal y mete todos los productos de una vez
      add.classList.toggle('btn--ghost',!packOn);add.classList.toggle('is-pack',packOn);
      add.textContent=nCarrito===0?((packOn&&L.cta_pack)||L.cta_vacio||''):(L.cta_seguir||'');
    }
    if(go)go.hidden=nCarrito===0;
    if(go&&!busy)go.textContent=L.cta_checkout||'';
    var umbral=(c.umbral||0)*100;
    if(env){
      if(!umbral||nCarrito===0){env.textContent='';env.classList.remove('is-ok')}
      else if(totalCarrito>=umbral){env.textContent=L.envio_ok||'';env.classList.add('is-ok')}
      else{env.textContent=tpl(L.envio_falta,money(umbral-totalCarrito,cur));env.classList.remove('is-ok')}
    }
    if(prog)prog.style.width=umbral?Math.min(100,Math.round(totalCarrito*100/umbral))+'%':'0';

    // ¿se enseña la barra?
    var oils=(c.productos||[]).filter(function(p){return p.clave!=='etnalia'}),
        alguno=oils.some(function(p){return venta(p.clave)}),
        on=c.show!==false&&vis>0&&(c.cuando==='siempre'||alguno);
    r.classList.toggle('is-on',on);
    r.setAttribute('aria-hidden',on?'false':'true');
    html.classList.toggle('rs-pedido-on',on);
    if(!on&&open)cerrar(r);
    r.querySelectorAll('button,input').forEach(function(b){if(!on)b.tabIndex=-1;else b.removeAttribute('tabindex')});
    marcasNav(c);
    avisaStock(c);
  }

  /* ── pack completo: una unidad de cada producto a la venta y con stock ───────────── */
  function packItems(c,claves){
    return (c.productos||[]).filter(function(p){return p.id&&p.available!==false&&venta(p.clave)&&(!claves||claves.indexOf(p.clave)>=0)});
  }
  function post(items){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(x){if(!x.ok)throw 0;return x.json()});
  }
  function anadePack(r,c,btn,claves){
    var lista=packItems(c,claves);if(!lista.length||busy)return;
    var L=c.labels||{};busy=true;
    if(btn){btn.disabled=true;btn.textContent=L.cta_anadiendo||btn.textContent}
    var items=lista.map(function(p){return {id:p.id,quantity:1}});
    // de una vez; si Shopify rechaza el lote (uno se acaba de agotar), uno a uno y lo que entre, entra
    post(items).catch(function(){
      var seq=Promise.resolve(),alguno=false;
      items.forEach(function(it){seq=seq.then(function(){return post([it]).then(function(){alguno=true}).catch(function(){})})});
      return seq.then(function(){if(!alguno)throw 0});
    }).then(function(){
      ultimo='';
      return window.fhRefreshCart?window.fhRefreshCart():null;
    }).then(function(){busy=false;return leeCarrito()})
      .then(function(){abrir(r)})
      .catch(function(){
        busy=false;if(btn){btn.disabled=false;btn.textContent=L.cta_error||''}
        setTimeout(function(){var rr=root(),cc=rr&&cfgOf(rr);if(cc)pinta(rr,cc)},2500);
      });
  }

  /* ── marcas en la navegación de arriba ──────────────────────────────────────────── */
  function marcasNav(c){
    var L=(c&&c.labels)||{};
    doc.querySelectorAll('.rsn__item[data-rs-ver-link]').forEach(function(a){
      if(a.closest('[data-rs-ped]'))return;
      var k=a.getAttribute('data-rs-ver-link'),qq=q(k),b=a.querySelector('[data-rs-nav-added]');
      if(qq>0){
        if(!b){
          b=doc.createElement('i');b.className='rs-nav-added';b.setAttribute('data-rs-nav-added','');b.setAttribute('aria-hidden','true');
          b.innerHTML='<svg width="9" height="9" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.3l2.4 2.4L9.6 3.9" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
          a.appendChild(b);
        }
        var num=b.querySelector('span');if(num)num.textContent=qq>1?qq:'';
        a.classList.add('is-added');
        if(L.nav_aria)a.setAttribute('aria-label',tpl(L.nav_aria,qq,(a.textContent||'').trim()));
      }else{
        if(b)b.remove();
        a.classList.remove('is-added');
        a.removeAttribute('aria-label');
      }
    });
  }

  // el resto de la página (CTA de cada producto) escucha esto
  function avisa(){
    var d={qty:{},count:cart.count,ultimo:ultimo};
    Object.keys(cart.qty).forEach(function(k){d.qty[k]=q(k)});
    Object.keys(pend).forEach(function(k){d.qty[k]=q(k)});
    try{doc.dispatchEvent(new CustomEvent('rs:carrito',{detail:d}))}catch(e){}
  }

  function abrir(r){
    var p=r.querySelector('[data-rs-ped-panel]'),t=r.querySelector('[data-rs-ped-toggle]');
    open=true;r.classList.add('is-open');if(p)p.hidden=false;if(t)t.setAttribute('aria-expanded','true');
  }
  function cerrar(r){
    var p=r.querySelector('[data-rs-ped-panel]'),t=r.querySelector('[data-rs-ped-toggle]');
    open=false;r.classList.remove('is-open');if(p)p.hidden=true;if(t)t.setAttribute('aria-expanded','false');
  }

  /* ── eventos ────────────────────────────────────────────────────────────────────── */
  doc.addEventListener('click',function(e){
    var r=root();if(!r)return;var c=cfgOf(r);if(!c)return;
    var t=e.target;
    if(t.closest('[data-rs-ped-toggle]')){open?cerrar(r):abrir(r);return}
    if(t.closest('[data-rs-ped-x]')){cerrar(r);return}
    var mas=t.closest('[data-rs-ped-mas]'),menos=t.closest('[data-rs-ped-menos]');
    if(mas||menos){
      var fila=(mas||menos).closest('[data-rs-ped-row]'),k=fila&&fila.getAttribute('data-rs-ped-row');
      if(!k)return;
      var nueva=Math.max(0,Math.min(c.max||10,q(k)+(mas?1:-1)));
      if(mas){var p=prodDe(c,k);ultimo=(p&&p.nombre)||ultimo}
      guarda(k,nueva);return;
    }
    var ab=t.closest('[data-rs-ped-add]');
    if(ab){
      if(ab.classList.contains('is-pack')){anadePack(r,c,ab);return}
      if(!open)abrir(r);else cerrar(r);return;
    }
    if(t.closest('[data-rs-ped-go]')){location.href='/checkout';return}
  });
  doc.addEventListener('keydown',function(e){
    if(e.key!=='Escape'||!open)return;
    var r=root();if(r)cerrar(r);
  });

  function init(){
    var r=root();if(!r)return;
    var c=cfgOf(r);if(!c)return;
    if(!open&&qs.get('ped')==='open')abrir(r);   // QA: ?ped=open enseña el panel abierto
    else if(!open)cerrar(r);
    carga(r,c);pinta(r,c);leeCarrito();
    if(timer)clearInterval(timer);
    timer=setInterval(function(){var rr=root();if(!rr)return;var cc=cfgOf(rr);if(cc)pinta(rr,cc)},30000);
  }
  // lo llaman los CTA de cada producto tras añadir: refresca y enseña el estado «añadido»
  function anadido(clave,nombre){
    var r=root(),c=r&&cfgOf(r);
    if(nombre)ultimo=nombre;
    else if(c){var p=prodDe(c,clave);if(p&&p.nombre)ultimo=p.nombre}
    leeCarrito();
  }
  // Pack de la cabecera (restock-hero): añade una unidad de cada clave y abre el panel; editar = abrir el panel
  function packDesde(claves,btn){var r=root(),c=r&&cfgOf(r);if(!c)return;anadePack(r,c,btn,claves)}
  function abrirPanel(){var r=root();if(r)abrir(r)}
  window.FHRestockPedido={init:init,added:anadido,refresh:leeCarrito,qty:function(k){return q(k)},pack:packDesde,abrir:abrirPanel};
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',init);else init();
  doc.addEventListener('shopify:section:load',init);
  doc.addEventListener('shopify:section:unload',function(){html.classList.remove('rs-pedido-on');setTimeout(init,0)});
  doc.addEventListener('rs:ver',function(){init();setTimeout(function(){var r=root(),c=r&&cfgOf(r);if(c)marcasNav(c)},50)});
  doc.addEventListener('rs:contenido',init);
  doc.addEventListener('cart:refresh',leeCarrito);
})();
